'use strict';

import { find, register } from '../../../JavaScript/Utils';

const ProductComparisonFeature = ($el) => {
    const toggle = find('[data-nezzo-feature-toggle]', $el);
    const toggleItem = find('[data-nezzo-feature-toggle-item]', $el);

    function closePreviousOpenedEl() {
        const currentToggleEl = $el.parentNode.querySelector('.productcomparison__feature-data-wrapper.open');
        const currentToggleItemEl = $el.parentNode.querySelector('.productcomparison__feature-description-wrapper.open');
        if (currentToggleEl) {
            currentToggleEl.classList.remove('open');
        }
        if (currentToggleItemEl) {
            currentToggleItemEl.classList.remove('open');
        }
    }

    toggle.addEventListener('click', () => {
        if (toggle.classList.contains('open')) {
            toggle.classList.remove('open');
            toggleItem.classList.remove('open');
        } else {
            closePreviousOpenedEl();
            toggle.classList.add('open');
            toggleItem.classList.add('open');
        }
    });
};

register('ProductComparisonFeature', ProductComparisonFeature);


